import { containsQuery, OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, request } from "services/request";

const resource = "api/expenses";

const list = (params: {}) => {
    return request(`${resource}/getlist${containsQuery(params)}`, { method: "GET" });
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: { ...preparedFilter } });

    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const apply = (params: {}) => {
    return alertRequest(`${resource}/apply`, body(params));
};

const getItem = ({ id }: { id: string }) => {
    return request(`${resource}/get/${id}`, { method: "GET" });
};

const delItem = (params: {}) => {
    return alertRequest(`${resource}/delete`, body(params));
};

const getFiles = (params: { id: number }) => {
    return request(`${resource}/getFiles/${params.id}`, { method: "GET" });
};

const uploadFile = (params: {}) => {
    return request(`${resource}/uploadFile`, params);
};

export { list, apply, index, getItem, delItem, getFiles, uploadFile };
